import {
  createActions
} from 'redux-actions';
import * as Types from '../types';

export const authenticationActions = createActions({
  [Types.AUTHENTICATION_SUCCESS]: (token, user) => ({ token, user }),
  [Types.AUTHENTICATION_FAILURE]: (error) => ({ error }),
  [Types.AUTHENTICATION_ATTEMPT]: () => ({}),
  [Types.AUTHENTICATION_LOGOUT]: () => ({})
});



// WEBPACK FOOTER //
// ./src/store/actions/authentication/index.js